import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/api";

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackEvent("pageview", location.pathname);
  }, [location.pathname]);
  return null;
};

export default AnalyticsTracker;
